import React, { useEffect } from 'react';
import { chipLabelEnumTransKey } from './enums';
import { connect } from 'react-redux';
import { changeFilters, changeSearchFieldIsInUse, getNFList } from '../../../../../../redux/tracking';
import { StyledChip } from './styles';

const ChipItem = ({ value, dispatch }) => {
  function handleDelete() {
    dispatch(changeFilters({ [value]: [] }));
    dispatch(getNFList());
  }

  useEffect(() => {
    dispatch(changeSearchFieldIsInUse(false));
  }, [])

  return (
    <StyledChip label={chipLabelEnumTransKey[value]} onDelete={handleDelete} />
  );
};

export default connect()(ChipItem);
